export class ExportConstants {
  public static readonly Excel = 'Excel';
  public static readonly Csv = 'CSV';
  public static readonly AppliedCalculation = 'AppliedCalculation';
  public static readonly Individuals = 'Individuals';
  public static readonly ResultValue = 'ResultValue';
  public static readonly Average = "Average";
  public static readonly SeeExamples = "SeeExample";
}
